import { BookOpen } from "lucide-react";
import { CodeMarkdown } from "@/components/storyboard/code/CodeMarkdown";
import ContentBlock from "@/components/storyboard/ContentBlock";
import type { CodeTheoryData } from "@/types/storyboard";

interface Props {
  data: CodeTheoryData;
}

export const CodeTheory = ({ data }: Props) => {
  return (
    <ContentBlock icon={BookOpen} title={data.title}>
      <div className="prose max-w-full text-primary">
        <CodeMarkdown>{data.theory}</CodeMarkdown>
      </div>
    </ContentBlock>
  );
};
